export default __webpack_public_path__ + "static/media/bkv.14d981c2.jpg";